import { render, staticRenderFns } from "./messagesWrapper.vue?vue&type=template&id=e2ed9aba&scoped=true&lang=html&"
import script from "./messagesWrapper.vue?vue&type=script&lang=js&"
export * from "./messagesWrapper.vue?vue&type=script&lang=js&"
import style0 from "./messagesWrapper.vue?vue&type=style&index=0&id=e2ed9aba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ed9aba",
  null
  
)

export default component.exports